module.exports = __webpack_public_path__ + "static/example-image-1-16cb81e17401d4e6d7b9ded0dabd2bad.jpg";